(function () {
  'use strict';

  angular
    .module('service.cdn', [])

    /* @ngInject */
    .factory('CdnService', ["AppService", function (AppService) {
      this.get = function (id, size, designation, extension, quality, absolute) {
        if (size === undefined) {
          size = '1200x1200';
        }
        if (designation === undefined) {
          designation = 'Image';
        }
        if (extension === undefined) {
          extension = 'jpg';
        }
        if (quality === undefined) {
          quality = 80;
        }
        if (absolute === undefined) {
          absolute = false;
        }

        return AppService.getParams()
          .then(function (params) {
            var split1 = params.Localization.UrlImages.substr(0, params.Localization.UrlImages.indexOf('.'));
            var split2 = params.Localization.UrlImages.substr(params.Localization.UrlImages.indexOf('.') + 1);
            var url = split1 === '' ? split2 : (split1 + id % 5 + '.' + split2);

            if (absolute && url.substr(0, 6) === '/Image') {
              url = params.Localization.URLSite.substr(0, params.Localization.URLSite.length - 1) + url;
            }

            if (quality <= 0) {
              quality = 1;
            }

            if (quality > 100) {
              quality = 100;
            }

            return quality === 80 ? url + '/' + id + '/' + size + '/' + _.kebabCase(_.deburr(designation)) + '.' + extension : url + '/' + id + '/' + size + '/' + _.kebabCase(_.deburr(designation)) + '.' + extension + '?quality=' + quality;
          })
          .catch(function (error) {
            throw error;
          });
      };

      return {
        get: this.get
      };
    }]);
})();
